<span class="header-text">Server Switcher</span>
<div class="container">
    <ng-container *ngFor="let e of envs">
        <!-- SHOW ENV ALSO IN THE SERVER SWITCHER ALONG WITH SERVERS -->
        <span *ngIf="showFpEnvInfo" class="env-title text-ellipsis">{{getEnvTitle(e)}}</span>
        <div class="srv-container" *ngFor="let s of e.entries"
             [class.srv-container-selected]="isCurrentSrv(s)">
            <img class="srv-icon" src="assets/images/shared/ic_server.svg" aria-hidden="true" alt=""/>
            <a class="srv-item text-ellipsis"
               (click)="onSelect(s)">{{getSrvTitle(s)}}</a>
        </div>
    </ng-container>
</div>
